(function () {
  const modal = document.querySelector('[data-ps-size-guide-modal]');
  if (!modal) return;

  function open(e) {
    if (e) e.preventDefault();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const closeBtn = modal.querySelector('.ps-sg-modal-close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 80);
  }

  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Explicit toggles (buttons / links carrying [data-ps-size-guide-toggle])
  document.querySelectorAll('[data-ps-size-guide-toggle]').forEach(function (t) {
    t.addEventListener('click', open);
  });

  // URL intercept: any <a href*="/pages/size-guide"> opens the modal instead of navigating.
  // Covers the footer menu link, the PDP size-guide link, and any future link to the page.
  // Graceful degradation: if JS fails, the link still navigates to the standalone page.
  document.querySelectorAll('a[href*="/pages/size-guide"]').forEach(function (a) {
    a.addEventListener('click', open);
  });

  // Close handlers
  modal.querySelectorAll('[data-ps-size-guide-close]').forEach(function (c) {
    c.addEventListener('click', close);
  });

  // Esc key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });
})();
